import React from "react";

const MapSelector = props => {
  const renderOptions = (option, i) => {
    if (option.mapStyle !== props.property) {
      return (
        <button
          onClick={() => props.changeState(i)}
          key={i}
          className="containerItem"
        >
          <img
            src={
              "https://api.mapbox.com/styles/v1/mapbox/" +
              option.mapStyle +
              "/static/173.2851,-41.277,12.91,0/50x55?access_token=pk.eyJ1IjoiZ2VvaW5zaWdodG56IiwiYSI6ImNrb3hybzJ2bTA0Z3cycHRhMG16Y2hzb2EifQ.Q_6eShFAXIFPa_rt_Pa5bw&attribution=false&logo=false"
            }
            alt={"Map Style " + option.name}
          />
        </button>
      );
    } else {
      return (
        <button key={i} className="containerItem" disabled>
          <img
            src={
              "https://api.mapbox.com/styles/v1/mapbox/" +
              option.mapStyle +
              "/static/173.2851,-41.277,12.91,0/50x55?access_token=pk.eyJ1IjoiZ2VvaW5zaWdodG56IiwiYSI6ImNrb3hybzJ2bTA0Z3cycHRhMG16Y2hzb2EifQ.Q_6eShFAXIFPa_rt_Pa5bw&attribution=false&logo=false"
            }
            alt={"Map Style " + option.name}
          />
        </button>
      );
    }
  };
  return (
    <div className="ml12 mb36 py6 px6 bg-white shadow-darken25 round">
      {/* {renderOptions(props.options[0], 0)} */}
      <div className="container-left ">{typeof props.options === 'undefined' ? <></> : props.options.map(renderOptions)}</div>
    </div>
  );
};

export default MapSelector;
